<h2 mat-dialog-title>Delete file {{data.title}}</h2>
<mat-dialog-content class="mat-typography">
  {{ data.subtitle}} <br>
  Would you like to delete file?
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="primary" mat-dialog-close cdkFocusInitial>No</button>
  <button mat-button color="accent" mat-dialog-close>Ok</button>
</mat-dialog-actions>